"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=corporate.dto.js.map